import { TableColumnsType } from 'antd';
import type { BillFormatDataType } from './types.ts';

// type StrictColumn<T> = {
//   [K in keyof T]:{
//     title: string;
//     dataIndex?: K;
//     key: string;
//     align?: 'left' | 'center' | 'right';
//   }
// }[keyof T];

export const billFormatListTableHeader: TableColumnsType<BillFormatDataType> = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Company',
    dataIndex: 'companyId',
    key: 'company',
    align: 'left',
    width: 200,
  },
  {
    title: 'Branch',
    dataIndex: 'branchId',
    key: 'branch',
    align: 'left',
    width: 150,
  },
  {
    title: 'Transaction Type',
    key: 'transactionType',
    dataIndex: 'transactionType',
    align: 'left',
    width: 120,
  },
  {
    title: 'Store',
    key: 'storeName',
    dataIndex: 'storeName',
    align: 'left',
    width: 180,
  },
  {
    title: 'Bill Prefix',
    key: 'billPrefix',
    dataIndex: 'billPrefix',
    align: 'left',
    width: 90,
  },
  {
    title: 'Bill Suffix',
    key: 'billSuffix',
    dataIndex: 'billSuffix',
    align: 'left',
    width: 90,
  },
  {
    title: 'Start Number',
    key: 'startNumber',
    dataIndex: 'startNumber',
    align: 'right',
    width: 100,
  },
  // {
  //   title: 'Financial Year',
  //   key: 'financialYearId',
  //   dataIndex: 'financialYearId',
  //   align: 'center',
  // },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    render: (action) => action,
    width: 80,
  },
];
